import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)


const zhTwLocaleFiles = require.context('./zh-tw', false, /\.js$/) ;
const zhTwLocales = zhTwLocaleFiles.keys().reduce(( zhTwLocales, localePath) => {
  Object.assign(zhTwLocales,  zhTwLocaleFiles(localePath).default );
  return zhTwLocales;
}, {});

const zhCnLocaleFiles = require.context('./zh-cn', false, /\.js$/) ;
const zhCnLocales = zhCnLocaleFiles.keys().reduce(( zhCnLocales, localePath) => {
  Object.assign(zhCnLocales,  zhCnLocaleFiles(localePath).default );
  return zhCnLocales;
}, {});

const enLocaleFiles = require.context('./en', false, /\.js$/) ;
const enLocales = enLocaleFiles.keys().reduce(( enLocales, localePath) => {
  Object.assign(enLocales,  enLocaleFiles(localePath).default );
  return enLocales;
}, {});


const jaLocaleFiles = require.context('./ja', false, /\.js$/) ;
const jaLocales = jaLocaleFiles.keys().reduce(( jaLocales, localePath) => {
  Object.assign(jaLocales,  jaLocaleFiles(localePath).default );
  return jaLocales;
}, {});

const messages = {
  en: {
    ...enLocales,
  },
  zhTw: {
    ...zhTwLocales,
  },
  zhCn: {
    ...zhCnLocales,
  },
  ja: {
    ...jaLocales,
  },
} // End of messages

function camelize(str){
  let arr = str.split('-');
  let capital = arr.map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item.toLowerCase());
  // ^-- change here.
  let capitalString = capital.join("");
  return capitalString ;
}


export function getLanguage() {
  const settingLanguage = localStorage.getItem('language') ;
  if ( settingLanguage ) return settingLanguage ;

  const language = camelize( navigator.language || navigator.browserLanguage ) ;
  const locales = Object.keys(messages) ;

  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
} // getLanguage()

const i18n = new VueI18n({
  locale: sessionStorage.getItem('language') || getLanguage(),
  messages
})

export default i18n
